import { useTranslate } from 'hooks/useTranslate';

const IncentivesMarketAdministratorBadge = () => {
  const { t } = useTranslate();

  return (
    <>
      <span className="badge badge-outline badge-primary mx-2">
        {t('Admin')}
      </span>
    </>
  );
};

export default IncentivesMarketAdministratorBadge;
